"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorId = void 0;
const getErrorId = (id) => `${id}-error`;
exports.getErrorId = getErrorId;
//# sourceMappingURL=index.js.map